var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"full-height":"","grey-back":""}},[_c('dialog-transaction-settings',{ref:"ref_dialogTransactionSettings",attrs:{"closeDialog":_vm.fn_closeDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }